import Vue from 'vue';
import { ErrorHandler } from '@/models/errors';

export default Vue.extend({
  name: 'ErrorForm',
  data: () => ({
    errors: new ErrorHandler(),
    validForm: false
  }),

  computed: {
    requiredRule() {
      return (field?: string) => [
        (v: string) => !!v || `${field || 'Field'} is required`
      ];
    },

    counterRule() {
      return (field: string, counter: number) => [
        (v: string) =>
          (v && v.length <= counter) ||
          `${field} must be less than ${counter} characters`
      ];
    }
  }
});
